"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("./Button.style");
var _spinner = _interopRequireDefault(require("@berlitz/spinner"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Button = function Button(_ref) {
  var as = _ref.as,
    canLoad = _ref.canLoad,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    ghost = _ref.ghost,
    ghostInvert = _ref.ghostInvert,
    href = _ref.href,
    icon = _ref.icon,
    inlineBlock = _ref.inlineBlock,
    innerRef = _ref.innerRef,
    loading = _ref.loading,
    onClick = _ref.onClick,
    small = _ref.small,
    target = _ref.target,
    rel = _ref.rel,
    to = _ref.to,
    type = _ref.type,
    outline = _ref.outline,
    buttonType = _ref.buttonType;
  var isLoading = loading && canLoad;
  return /*#__PURE__*/_react.default.createElement(_Button.ButtonStyled, {
    "aria-hidden": isLoading,
    as: as,
    buttonType: buttonType,
    canLoad: canLoad,
    className: className,
    "data-key": "max-button",
    disabled: disabled || isLoading,
    fullWidth: fullWidth,
    ghost: ghost,
    ghostInvert: ghostInvert,
    href: href,
    icon: icon,
    inlineBlock: inlineBlock,
    loading: isLoading,
    onClick: onClick,
    outline: outline,
    ref: innerRef,
    rel: rel,
    small: small,
    target: target,
    to: to,
    type: type
  }, /*#__PURE__*/_react.default.createElement(_Button.Inner, {
    loading: isLoading
  }, children, icon && /*#__PURE__*/_react.default.createElement(_Button.IconWrapper, null, icon)), canLoad && /*#__PURE__*/_react.default.createElement(_Button.LoadingContainer, {
    "aria-busy": isLoading,
    "aria-hidden": !isLoading,
    loading: isLoading
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    light: true,
    size: "sm"
  })));
};
Button.defaultProps = {
  canLoad: null,
  fullWidth: null,
  ghost: false,
  ghostInvert: false,
  icon: null,
  inlineBlock: false,
  outline: false,
  type: 'button',
  buttonType: 'default'
};
var _default = Button;
exports.default = _default;